<template>
  <component :is="calculator" v-if="calculator" />
</template>

<script>
import { mapState } from 'vuex';
import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';
import ConfidenceInterval from './ConfidenceInterval.vue';
import MeanMedianMode from './MeanMedianMode.vue';
import Skewness from './Skewness.vue';
import Kurtosis from './Kurtosis.vue';
import Variance from './Variance.vue';
import StandardDeviation from './StandardDeviation.vue';
import CoefficientOfVariation from './CoefficientOfVariation.vue';
import LinearRegression from './LinearRegression.vue';

export default {
  components: {
    ConfidenceInterval,
    MeanMedianMode,
    Skewness,
    Kurtosis,
    Variance,
    StandardDeviation,
    CoefficientOfVariation,
    LinearRegression,
  },
  computed: {
    ...mapState('calculators', ['result', 'calculator']),
  },
  watch: {
    result() {
      this.$nextTick(() => this.renderMathJax());
    },
  },
  mounted() {
    this.$nextTick(() => this.renderMathJax());
  },
  methods: {
    renderMathJax() {
      if (window.MathJax) {
        window.MathJax.Hub.Config({
          tex2jax: {
            inlineMath: [['$', '$'], ['\\(', '\\)']],
            processEscapes: true,
          },
          'HTML-CSS': {
            linebreaks: { automatic: true, width: 'container' },
          },
          SVG: {
            linebreaks: { width: '500000px' },
          },
          jax: ['input/TeX', 'output/SVG'],
        });
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub]);
        document.querySelectorAll('pre code:not(.hljs)').forEach((block) => {
          hljs.highlightElement(block);
        });
      }
    },
  },
};
</script>
